import DocumentsSection from "./Documents";
export const FlaggedByQcDocument = () => {
  return <DocumentsSection />;
};
export const AwatingReviewDocument = () => {
  return <DocumentsSection />;
};
export const FinalizedDocument = () => {
  return <DocumentsSection />;
};
